import { useReferentialUserStates } from "@/entities/referential/referential-user-states";
import { Tag } from "@/ui/tag";

const UserState = ({ user }) => {
  const { userStates } = useReferentialUserStates();
  const stateRefrentiel = userStates.find(
    (referentiel) =>
      user.state.toLowerCase() === referentiel?.value.toLowerCase()
  );

  if (!stateRefrentiel) return null;

  return <Tag color={stateRefrentiel.color}>{stateRefrentiel.name}</Tag>;
};

export default UserState;
